// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Step02Partner } from '@/modules/wizard/steps/Step02Partner'
import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useReturnNav } from '@/lib/returnNav'
import { PrimaryActionButton } from '@/components/ui/PrimaryActionButton'
import { SecondaryActionButton } from '@/components/ui/SecondaryActionButton'
import { CheckCircle2 } from 'lucide-react'
import { SaveStatusBadge } from '@/components/ui/SaveStatusBadge'
import { RegieCoachBlock } from '@/components/process/RegieCoachBlock'
import { ClosingGuidance } from '@/components/process/ClosingGuidance'
import type { SaveStatus } from '@/hooks/useAutosave'

export function PartnerPage() {
  const [saveStatus, setSaveStatus] = useState<SaveStatus>('idle')
  const saveRef  = useRef<(() => Promise<void>) | null>(null)
  const navigate = useNavigate()
  const { target, label } = useReturnNav()
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <button onClick={async () => { await saveRef.current?.(); navigate(-1) }}
          className="flex items-center gap-1.5 text-sm text-ink-4 hover:text-ink-3 transition-colors mb-5 group">
          <svg className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Terug naar vorige scherm
        </button>
        <SaveStatusBadge status={saveStatus} />
      </div>
      <Step02Partner onSaveStatus={setSaveStatus} saveRef={saveRef} />
      <RegieCoachBlock page="partner" />
      <ClosingGuidance title="Uw naasten weten waar zij aan toe zijn">
        Bespreek belangrijke keuzes regelmatig met elkaar. Dat voorkomt onzekerheid wanneer er later beslissingen moeten worden genomen.
      </ClosingGuidance>
      <div className="flex flex-col gap-2 mt-2">
        <PrimaryActionButton onClick={async () => { await saveRef.current?.(); navigate(target) }} icon={<CheckCircle2 className="h-5 w-5" />}>
          {label}
        </PrimaryActionButton>
        <SecondaryActionButton onClick={async () => { await saveRef.current?.(); navigate(-1) }}>Terug naar vorige scherm</SecondaryActionButton>
      </div>
    </div>
  )
}
